import styled from 'styled-components';

export const cardsBox = styled.div`
  z-index: 5;
  margin-top: ${(p) => p.marginTop || 0};
  position: relative;
  background: transparent;
`;

export const CardLinksBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 2rem;
  `;

export const CardLinks = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #ffffff;
    border-radius: 1rem;
    
    padding: 1rem;
    width: 21.75rem;
    height: 8rem;
    
    box-shadow: 0 0 0 1px rgba(0,0,0,0.04);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    
    &:hover {
      box-shadow: 0 10px 24px rgba(0,0,0,0.08);
      transform: translateY(-2px);
    }
    
    h5 {
      display: flex;
      gap: .5rem;
      font-weight: var(--font-weight-semibold);
      font-weight: 600;
      font-size: 0.95rem;
      letter-spacing: 0.02em;
      align-items: center;
      margin: 0.5rem 0 0.5rem;
      color:#065F46;
    }

    p {
      color: #4b5563;
      font-size: 0.95rem;
      min-height: 3rem;
    }

    a {
      display: inline-block;
      border: 1px solid #16a34a;
      align-self: flex-start;
      padding: 0.5rem 1rem;
      border-radius: 0.625rem;
      text-decoration: none;
      transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
      color: #16a34a;
      font-size: 14px;
      :hover{
        background: #DBFCE7;
        color: #4b5563; 
        border-color: #16a34a;
      }
    }

    .NavLink{
      color: #065f46; /* emerald-700 */
    }
`;
